export default {
  applicationName: "",
  GAeventType: "UXEvent",
  GAEvents: []
};
